import {CardColor} from "./api/CardColor";
import {CardName} from "./api/CardName";
import {Card} from "./Card";

export class AceCard extends Card {

    private alternativeValue: number;

    constructor(color: CardColor, name: CardName, value: number, alternativeValue: number) {
        super(color, name, value);
        this.alternativeValue = alternativeValue;
    }

    public getAlternativeValue(): number {
        return this.alternativeValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/AceCard.ts